import { render, staticRenderFns } from "./ResourcePermissionsComponent.vue?vue&type=template&id=f6908828&scoped=true&"
import script from "./ResourcePermissionsComponent.vue?vue&type=script&lang=ts&"
export * from "./ResourcePermissionsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcePermissionsComponent.vue?vue&type=style&index=0&id=f6908828&scoped=true&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f6908828",
  null
  
)

export default component.exports